module.exports = __webpack_public_path__ + "assets/img/00b2b922d1a007c53b5845dfc54f609e.webp";